    <template>
        <div class="col-12">
        
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-10 col-lg-6">
                    <div class=" row text-center ml-5">
                        <div class="mb-5">
                            <img src="../../assets/tn_cybertech_grad_logo.png" class="tn-logo" style="width: 200px; height: auto;" alt="">
                        </div>
                        <h3 class="ui inverted purple text"><strong>What would you like to do?</strong></h3>
                        <p class="text-muted mt-4">Open a new bank account or track the status of your existing applications.</p>
                    </div>
                    <div class="ui fitted divider mt-2"></div>
                </div>
            </div>

            <div class="row d-flex justify-content-center align-items-center mt-5">
                <div class="col-11 col-lg-9">

                    <div class="row mb-5">
                        <div class="col-sm-6 mb-3">
                            <div class="card card-shadow border-dark">
                                <div class="card-body">
                                    <h4 class="card-title"><strong>Open an account</strong></h4>
                                    <p class="card-text text-muted fw-light">Open a TN CyberTech Bank account</p>
                                    <br>
                                    <button class="ui purple large basic right floated  button" @click="openAccount()">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-6 mb-3">
                            <div class="card card-shadow">
                                <div class="card-body">
                                    <h4 class="card-title"><strong>Upgrade iSave Account</strong></h4>
                                    <p class="card-text text-muted fw-light">Update your low kyc account for more flexible business conditions</p>
                                    <button class="ui purple right floated button" @click="iSaveUpgrade()">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-sm-6 mb-3">
                            <div class="card card-shadow border-dark">
                                <div class="card-body">
                                    <h4 class="card-title"><strong>View Applications</strong></h4>
                                    <p class="card-text text-muted fw-light">View existing applications and make changes
                                        where necessary</p>
                                    <button class="ui large purple basic right floated button" @click="viewAccountApplications()">
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5">
                        <button @click="back()" class="ui grey large basic button fluid">Back</button>
                    </div>
                </div>
            </div>
        </div>
        

    </template>
    <script>
    import baseMethods from "@/utils/baseMethods";
    import { utils } from "@/utils/utils";
    import { URLS } from "@/utils/constants";
    import { useAuthStore } from '@/stores/auth';
    import { useAccountOpeningStore } from '@/stores/accountOpening';
    import { Notify } from "../../utils/notifications";

    export default {
        name: "Home",
        setup() {
            const authStore = useAuthStore();
            const accountOpeningStore = useAccountOpeningStore();
            return { authStore, accountOpeningStore };
        },
        data() {
            return { count: 0 };
        },
        computed: {
            userId() { return this.authStore.userId; },
            user() { return this.authStore.user; },
            isAuthenticated() { return this.authStore.isAuthenticated; },
            accessToken() { return this.authStore.accessToken; },
            customerStatus() { return this.authStore.customerStatus; },
        },
        mounted() {
            this.initializePage();
        },
        methods: {
            initializePage() {
                // Check if we have a token from URL params (external redirect flow)
                const urlToken = this.$route.params.token;
                if (urlToken) {
                    this.setAccessToken(urlToken);
                    this.fetchUserData();
                    return;
                }

                // Check if already authenticated from login
                if (this.isAuthenticated) {
                    return;
                }

                // Allow REGISTER users through without a token (they haven't registered yet)
                if (this.customerStatus === 'REGISTER') {
                    return;
                }

                // Not authenticated, redirect to login
                this.$router.push("/omni");
            },
            fetchUserData() {
                this.get_auth('/auth/user')
                    .then((res) => {
                        if (res && res.success) {
                            // Store user data in Vuex
                            this.setUser(res.body.user);
                        } else {
                            Notify.fire("Error", "Failed to fetch user data", "error");
                            this.$router.push("/omni");
                        }
                    })
                    .catch(e => {
                        utils.logger(e);
                        Notify.fire("Error", "Session expired. Please login again.", "error");
                        this.$router.push("/omni");
                    });
            },
            getActiveAccounts() {
                this.get_sso_no_auth(URLS.sso_accounts + '/active-accounts/' + this.userId).then((res) => {
                    console.log(res);
                    const accountTypes = res.body.accounts.map(account => ({
                        accountType: account.account_type,
                        currencyType: account.currency
                    }));

                    // Store active account types in Vuex
                    this.setActiveAccountTypes(accountTypes);
                })
            },
            back() {
                this.$router.push("/omni/main");

            },
            openAccount() {
                this.$router.push("/omni/terms-and-conditions");
            },
            viewAccountApplications() {
                this.$router.push("/omni/view-account-applications");
            },
            iSaveUpgrade() {
                this.$router.push("/account-opening/iSave-list");
            },
            submitForm() {
            },
            login(data) { this.authStore.login(data); },
            setAccessToken(token) { this.authStore.setAccessToken(token); },
            setUser(user) { this.authStore.setUser(user); },
            setActiveAccountTypes(types) { this.accountOpeningStore.setActiveAccountTypes(types); },
            ...baseMethods,
        }
    };
    </script>